import React, { useEffect, useState } from "react";
import axios from "axios";

function TrabajdoresInforme(props) {
  const [datos, setDatos] = useState([]);
  const [paginaActual, setPaginaActual] = useState(1);
  const itemsPorPagina = 5;

  useEffect(() => {
    axios
      .get(
        "https://suadesarrollo.azurewebsites.net/api/ObtenerSolicitudTrabajadoresPorInstitucionId?InstitucionId=" +
          props.id,
      )
      .then((response) => {
        setDatos(response.data);
      })
      .catch((error) => {
        console.error("Error al obtener los datos", error);
      });
  }, [props.id]);

  // Calcular paginación
  const totalPaginas = Math.ceil(datos.length / itemsPorPagina);
  const indiceInicio = (paginaActual - 1) * itemsPorPagina;
  const indiceFin = indiceInicio + itemsPorPagina;
  const datosPagina = datos.slice(indiceInicio, indiceFin);

  const irPaginaAnterior = () => {
    if (paginaActual > 1) {
      setPaginaActual(paginaActual - 1);
    }
  };

  const irPaginaSiguiente = () => {
    if (paginaActual < totalPaginas) {
      setPaginaActual(paginaActual + 1);
    }
  };

  return (
    <div className="container">
      <div className="text-center">
        <div className="container-fluid">
          <div className="card shadow mb-4">
            <div className="card-body">
              <div className="table-responsive">
                <h6 class="m-0 font-weight-bold text-primary">
                  Información de trabajadores
                </h6>{" "}
                <br></br>
                <table
                  className="table table-bordered text-justify"
                  width="100%"
                  cellSpacing="0"
                >
                  <thead>
                    <tr>
                      <th>Nivel De Formación</th>
                      <th>Descripción Perfil</th>
                      <th>Calificación Asistencial</th>
                      <th>Calificación Administrativa</th>
                      <th>Calificación Asistencial/Administrativa</th>
                      <th>Total 1</th>
                      <th>Planta</th>
                      <th>Prestación de Servicios</th>
                      <th>Terceros</th>
                      <th>Trabajadores Servicios</th>
                      <th>Otros</th>
                      <th>Total 2</th>
                      <th>Fecha Corte</th>
                    </tr>
                  </thead>

                  <tbody>
                    {datosPagina.map((item) => (
                      <tr key={item.id}>
                        <td>{item.descripcionPerfil}</td>
                        <td>{item.descripcionOtros}</td>
                        <td>{item.asistenciales}</td>
                        <td>{item.administrativas}</td>
                        <td>{item.asistencialesAdministrativas}</td>
                        <td>{item.total1}</td>
                        <td>{item.planta}</td>
                        <td>{item.prestacionServicios}</td>
                        <td>{item.terceros}</td>
                        <td>{item.trabajadoresServicios}</td>
                        <td>{item.otros}</td>
                        <td>{item.total2}</td>
                        <td>{item.fechaCorte}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {/* Paginador */}
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <button
                    className="btn btn-primary"
                    onClick={irPaginaAnterior}
                    disabled={paginaActual === 1}
                  >
                    Anterior
                  </button>

                  <span>
                    Página {paginaActual} de {totalPaginas}
                  </span>

                  <button
                    className="btn btn-primary"
                    onClick={irPaginaSiguiente}
                    disabled={paginaActual === totalPaginas}
                  >
                    Siguiente
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TrabajdoresInforme;
